module.exports = __webpack_public_path__ + "img/21.40e3f640.png";